export const AUTH_TOKEN_KEY = 'vammo_auth_token'

function normalizeToken(rawToken) {
  if (typeof rawToken !== 'string') return null
  const trimmed = rawToken.trim()
  if (!trimmed) return null

  // Support accidental quoted values from copy/paste.
  if (
    (trimmed.startsWith('"') && trimmed.endsWith('"')) ||
    (trimmed.startsWith("'") && trimmed.endsWith("'"))
  ) {
    const unquoted = trimmed.slice(1, -1).trim()
    return unquoted || null
  }

  return trimmed
}

export function readAuthToken() {
  return normalizeToken(sessionStorage.getItem(AUTH_TOKEN_KEY))
}

export function writeAuthToken(token) {
  const normalized = normalizeToken(token)
  if (!normalized) {
    sessionStorage.removeItem(AUTH_TOKEN_KEY)
    return null
  }

  sessionStorage.setItem(AUTH_TOKEN_KEY, normalized)
  return normalized
}

export function clearAuthToken() {
  sessionStorage.removeItem(AUTH_TOKEN_KEY)
}

